import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

const Modal = ({ uniqueId, headerTitle, showExclamationIcon, buttons, children, bodyClass, containerClass, hideHeader, footerClass, hideCloseButton }) => {
  // Use React Portal to render the modal at the end of <body>.
  // This solves z-index and stacking context issues (like those caused by transform)
  // because the modal is no longer nested inside the component hierarchy in the DOM.

  const modalJSX = (
    <div className="modal fade" id={uniqueId} tabIndex="-1" role="dialog" aria-hidden="true">
      <div className={`modal-dialog ${containerClass || ''}`} role="document">
        <div className="modal-content">
          {!hideHeader && (
            <div className="modal-header d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                {showExclamationIcon && <i className="material-icons text-warning mr-2">warning</i>}
                <div id="first-modal" className="modal-title">
                  {uniqueId === 'setting-displayed-name-modal' ? `Change ${headerTitle}` : headerTitle}
                </div>
              </div>
              {!hideCloseButton && (
                <button className="close close-modal-btn" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              )}
            </div>
          )}
          <div className={bodyClass}>{children}</div>

          <div className={footerClass || "modal-footer"}>
            {buttons && buttons.map(({ className, clickHandler, name }, i) => (
              <button
                key={i}
                className={`btn ${className}`}
                data-dismiss="modal"
                onClick={clickHandler}>
                {name}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalJSX, document.body);
};

Modal.propTypes = {
  uniqueId: PropTypes.string.isRequired,
  headerTitle: PropTypes.any,
  showExclamationIcon: PropTypes.bool,
  children: PropTypes.any.isRequired,
  containerClass: PropTypes.string,
  footerClass: PropTypes.string,
  hideHeader: PropTypes.bool,
  hideCloseButton: PropTypes.bool,
  buttons: PropTypes.arrayOf(
    PropTypes.exact({
      name: PropTypes.string.isRequired,
      className: PropTypes.string.isRequired,
      clickHandler: PropTypes.func,
    }),
  ).isRequired,
};

export default Modal;
